import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function DbAzure() {
    const [inputData, setInputData ]  = useState('')
    const [viewData, setViewData] = useState('')
    const onClick2Get =async() =>{
      try {
       const { data: res } = await axios.get(`${APIURL}/basic/db_json`)
        return setInputData(JSON.stringify(res))
      } catch (err) {
        console.log(err)
      }
    }
    const onClick2View = () => { 
      //get > no edit
      if(typeof viewData =='string' || viewData ==''){
        setViewData(JSON.parse(inputData)) 
      //get > edited
      }else{
        setViewData(JSON.stringify(inputData)) 
      }
    } 
    const onClick2Save = async() => { 
      try {
        const { data: res } = await axios.post(`${APIURL}/basic/db_json`, {data: inputData})
      } catch (err) {
        console.log(err)
      }
    } 
    const onClick2Clear = () => { 
        setInputData('')
        setViewData('')
    } 
      return (
        <>
        <div className='text-[9px]'>
        <div className='flex mb-[4px]'>
        <button className='border border-gray-800 mr-[1px] pl-[2px] pr-[2px] bg-gray-200 hover:bg-gray-300' onClick={onClick2Get}>get</button>
        <button className='border border-gray-800 mr-[1px] pl-[2px] pr-[2px] bg-gray-200 hover:bg-gray-300' onClick={onClick2View}>view</button>
        <button className='border border-gray-800 mr-[1px] pl-[2px] pr-[2px] bg-gray-200 hover:bg-gray-300' onClick={onClick2Save}>save at server</button>
        <button className='border border-gray-800 pl-[2px] pr-[2px] bg-gray-200 hover:bg-gray-300' onClick={onClick2Clear}>clear</button>
        </div>
        data: <input className='border border-gray-800 w-[240px]' value={inputData} onChange={(e)=>setInputData(e.target.value)}/><br/>
        view: {typeof viewData !='string' && viewData != ''?<>{viewData.map(x=><>{x.name} </>)}</> :''}
        <br/>
        stored place: inspector tool > storage > Local Storage
        </div>
        </>
      )
}

